import {
  CasEntityRHFSelect,
  CasEntitySelect,
  componentProps,
  CasEntitySelectProps,
} from 'src/compass/shared/components';

const entity = "Employee/RiskManager";

export function CasRHFRiskManagerSelect({
  limitBusDev = false,
  ...props
}: CasEntitySelectProps & { limitBusDev?: boolean }) {
  return CasEntityRHFSelect(entity, { ...props, params: { ...props.params, limitBusDev } });
}

export function CasRiskManagerSelect({
  limitBusDev = false,
  ...props
}: componentProps & { limitBusDev?: boolean }) {
  return CasEntitySelect(entity, { ...props, params: { ...props.params, limitBusDev } });
}
